import React, { useEffect, useState } from 'react'

import { QueryClient, QueryClientProvider } from 'react-query'
import { useSelector } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import { ThemeProvider as DDSThemeProvider, ToastProvider } from '@driftt/dds'
import { DriftAnalytics } from '@driftt/dds.analytics'

import Settings from 'components/Settings'
import IntegrationErrorContext from 'contexts/integrationError'

import './style.css'

const queryClient = new QueryClient()

const AppLayout = () => {
  const [integrationErrorContext, setIntegrationErrorContext] = useState({})
  const [logRocketInitialized, setLogRocketInitialized] = useState(false)
  const driftUser = useSelector((state) => state.user)

  useEffect(() => {
    if (!driftUser) {
      return
    }

    if (!logRocketInitialized) {
      setLogRocketInitialized(true)
      DriftAnalytics.initialize({ user: driftUser })
    }
  }, [driftUser, logRocketInitialized])

  return (
    <QueryClientProvider client={queryClient}>
      <DDSThemeProvider>
        <ToastProvider>
          <Router basename="/settings2">
            <div className="settings-layout">
              <IntegrationErrorContext.Provider
                value={{
                  integrationErrors: integrationErrorContext,
                  setIntegrationErrorContext: setIntegrationErrorContext,
                }}
              >
                <Settings />
              </IntegrationErrorContext.Provider>
            </div>
          </Router>
        </ToastProvider>
      </DDSThemeProvider>
    </QueryClientProvider>
  )
}

export default AppLayout
